import { render, staticRenderFns } from "./progress-circle.vue?vue&type=template&id=2b0de475&scoped=true"
import script from "./progress-circle.vue?vue&type=script&lang=ts"
export * from "./progress-circle.vue?vue&type=script&lang=ts"
import style0 from "./progress-circle.vue?vue&type=style&index=0&id=2b0de475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0de475",
  null
  
)

export default component.exports